import { useContext } from 'react'

import { FirebaseUserContext } from './FirebaseUserContextValue.ts'

export const useFirebaseUser = () => useContext(FirebaseUserContext)
export const useAuthenticatedFirebaseUser = () => {
  const user = useFirebaseUser()
  if (!user) throw new Error('User is not authenticated')
  return user
}
